import { autoUpdate, computePosition, flip } from '@floating-ui/dom'

const Dropdown = {
  mounted() {
    const source = this.source(this.el)
    const target = this.target(this.el)
    const placement = this.el.getAttribute('data-dropdown-placement') || 'bottom-end'
    const js = this.js()

    this.el.querySelectorAll('[role=menuitem]').forEach((element) => {
      element.addEventListener('click', (_event) => {
        js.setAttribute(source, 'aria-expanded', 'false')
        js.addClass(target, 'hidden')
      })
    })

    this.cleanup = autoUpdate(source, target, () => {
      computePosition(this.el, target, {
        placement,
        middleware: [flip()],
      }).then(({ x, y }) => {
        Object.assign(target.style, { left: `${x}px`, top: `${y}px` })
      })
    })
  },

  source(element) {
    const id = element.getAttribute('data-dropdown-id')

    return document.getElementById(`dropdown-${id}-trigger`)
  },

  target(element) {
    const id = element.getAttribute('data-dropdown-id')

    return document.getElementById(`dropdown-${id}-menu`)
  },

  destroyed() {
    this.cleanup()
  },
}

export default Dropdown
